import Cookies from 'js-cookie';
import $ from "jquery";

var ready = require('document-ready');

ready(function () {
  function unhideMessage() {
    $('.cookie-banner').attr("style", "display: block !important");
  }

  // set cookie message to not display
  function hideMessage() {
    $('.cookie-banner').attr("style", "display: none !important");
  }

  function appendSuccessBanner($target) {
    if($('.notification-banner--success').length === 0) {
      const banner = '<div class="notification-banner notification-banner--success" role="alert" aria-labelledby="notification-banner-title" data-module="notification-banner"><div class="notification-banner__heading"><span class="notification-banner__title" id="notification-banner-title">Success</span></div><div class="notification-banner__content"><p class="notification-banner__heading">You’ve set your cookie preferences. <a class="notification-banner__link" href="javascript:history.back()">Go back to the page you were looking at</a>.</p></div></div>';

      $target.append(banner);
    }
  }

  function testTrackingCookie(choice) {
      // if $.cookie value is true, set Matomo and return
      if(parseInt(choice) === 1) {
        setMatomo();
      }
  }

  function updateCookie(consent) {
    // check for existing cookie and remove before creating a new one
    if(Cookies.get('stats-allowed')) {
      Cookies.remove('stats-allowed', { path: '/' });
    }

    // create a cookie which is valid for 365 days on all site pages
    Cookies.set('stats-allowed', consent, { expires: 365, path: '/', sameSite: 'lax'})
  }

  function setMatomo() {
    var _paq = window._paq = window._paq || [];
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    (function() {
      var u="//stats.xebre.net/";
      _paq.push(['setTrackerUrl', u+'matomo.php']);
      _paq.push(['setSiteId', '27']);
      var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
      g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
    })();
  }

  // check if stats cookie exists and return value
  var c = Cookies.get('stats-allowed');

  // make cookie choice appear if $.cookie is undefined
  if(typeof c === 'undefined') {
    unhideMessage();
  } else {
      testTrackingCookie(c);
  }

  // when user clicks no, a stats cookie is created and set to false
  $('button[value="reject"]').click(function() {
    updateCookie(0);
    hideMessage();
  });

  // when user click yes, a stats cookie is created and set to true
  $('button[value="accept"]').click(function() {
    updateCookie(1);
    hideMessage();
    testTrackingCookie(true);
  });

  $('#cookie-radio-submit-button').click(function() {
    if($('#analytics-cookies').is(':checked')) {
      updateCookie(1);
      hideMessage();
      appendSuccessBanner($('#cookie-radio-form'));
      testTrackingCookie(true);
    } else if($('#analytics-cookies-2').is(':checked')) {
      updateCookie(0);
      hideMessage();
      appendSuccessBanner($('#cookie-radio-form'));
    }
  });
})
